<template>
  <b-container class="text-center py-5">
    <div v-if="status === 'loading'">
      <p class="text-muted">Unsubscribing…</p>
    </div>
    <div v-else-if="status === 'success'">
      <i class="fas fa-circle-check unsubscribe-icon"></i>
      <h1>You've been unsubscribed</h1>
      <p class="text-muted">You will no longer receive email notifications from Zerticarbon. You can re-enable them any time from your Notifications preferences.</p>
      <router-link class="btn btn-primary mt-2" to="/">Back to Zerticarbon</router-link>
    </div>
    <div v-else>
      <i class="fas fa-circle-exclamation unsubscribe-icon error"></i>
      <h1>Link not valid</h1>
      <p class="text-muted">This unsubscribe link is invalid or has expired.</p>
      <router-link class="btn btn-primary mt-2" to="/">Back to Zerticarbon</router-link>
    </div>
  </b-container>
</template>

<script>
import NotificationPreference from '../api/NotificationPreference'

export default {
  name: 'Unsubscribe',
  data() {
    return {
      status: 'loading'
    }
  },
  created() {
    NotificationPreference.unsubscribe(this.$route.params.token)
      .then(() => {
        this.status = 'success'
      })
      .catch(() => {
        this.status = 'error'
      })
  }
}
</script>

<style scoped>
.unsubscribe-icon {
  font-size: 3rem;
  color: var(--accent-green);
  margin-bottom: 16px;
  display: block;
}

.unsubscribe-icon.error {
  color: #e85d5d;
}
</style>
